import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

export const LaunchBulkMarkSaleAsPaid = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  return (
    <>
      <PosDropdownItem
        key="mark-sale-as-paid"
        onClick={onClick}
        disabled={disabled}
      >
        <Stack gap="m" alignItems="center" width="full">
          <span style={{ textAlign: 'left' }}>
            <Content id={ContentId.MarkAsPaid} />
          </span>
        </Stack>
      </PosDropdownItem>
    </>
  );
};
